import { memo } from 'react';
import { Box, SpaceBetween, Spinner, TextContent } from '@amzn/awsui-components-core';

import ActionPanelBase from './ActionPanelBase';
import { ActivityEntryViewModel, useActivityPanelViewModel } from './ActivityPanelViewModel';
import { PanelDivider } from './PanelDivider';

function ActivityEntry({ entry }: { readonly entry: ActivityEntryViewModel }) {
  return (
    <div>
      <span>
        <Box variant="strong">{entry.actionLabel}</Box> by {entry.userId}
      </span>
      <Box variant="small" display="block" color="text-body-secondary">
        {entry.timestamp}
      </Box>
      {entry.comment && (
        <Box variant="small" display="block" color="text-body-secondary">
          &ldquo;{entry.comment}&rdquo;
        </Box>
      )}
    </div>
  );
}

export const ActivityPanel = memo(function ActivityPanel() {
  const vm = useActivityPanelViewModel();

  return (
    <ActionPanelBase title="Activity">
      <SpaceBetween size="xs" direction="vertical">
        <TextContent>
          {vm.isShowingUnpublishedVersion ? (
            <p>
              These actions have been taken on this version of the content and the version that was
              unpublished. For earlier versions, see the <strong>History</strong> tab.
            </p>
          ) : (
            <p>
              These actions have been taken on this version of the content. For previous versions,
              see the <strong>History</strong> tab.
            </p>
          )}
        </TextContent>

        <PanelDivider />

        {vm.isLoading && <Spinner size="normal" />}

        {!vm.isLoading && vm.entries.length === 0 && (
          <Box textAlign="center" color="text-body-secondary" padding="l">
            No activity yet
          </Box>
        )}

        {!vm.isLoading &&
          vm.entries.map((entry) => <ActivityEntry key={entry.eventId} entry={entry} />)}
      </SpaceBetween>
    </ActionPanelBase>
  );
});
